export class SimpleBookingEmailTemplate {

    constructor(
        public body: string,
        public subject: string,
        public backgroundColor: string | null
    ){}
}
